import AuthService from '../services/login';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { fstatus: { loggedIn: true }, user }
  : { fstatus: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          if(user){
            commit('loginSuccess', user);
            return Promise.resolve(user);
          }else {
            commit('loginFailure');
            return Promise.reject(user);
          }
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.fstatus.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.fstatus.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.fstatus.loggedIn = false;
      state.user = null;
    }
  }
};
